import React from 'react'
import profileImg from '../../Images/profile.png'
import { IoIosArrowDown } from "react-icons/io";
import { Link, NavLink } from 'react-router-dom';
import { TiThMenu } from "react-icons/ti";
import { useState } from 'react';



type AgentProfileProps = {
  menuicon: React.ReactNode;
};

const Agentprofile: React.FC<AgentProfileProps> =({menuicon}) =>{
        const [showPopup, setshowPopup] = useState(false);
    
    return (
          <>
            <div className='w-[100%] flex justify-between p-4 pr-[40px] bg-white '>
                 {menuicon}
                 <div className='flex justify-center items-center gap-5'>
                    <h1 className='text-red-600 font-bold'> 302232</h1>
                <div className='flex justify-center items-center gap-2 cursor-pointer' onMouseOver={() => { setshowPopup(true) }} onMouseOut={() => { setshowPopup(false) }}><img className='w-[32px]' src={profileImg} alt="" /> <span className='flex justify-center items-center font-[500] text-[14px] text-gray-700 '>seller_1001 
                    <IoIosArrowDown /></span></div>
            </div>
            </div>

            {showPopup &&
                <div className='absolute right-[10px] top-[50px] pt-12 pr-2' onMouseOver={() => { setshowPopup(true) }} onMouseOut={() => { setshowPopup(false) }} >
                    <div className='bg-white rounded-md p-2 w-[150px] flex flex-col gap-4 mt-[-20px] ' >

                        <NavLink to='profile'
                            className={({ isActive }) =>
                                `text-sm font-medium ${isActive ? 'text-[#7a70ba]' : 'text-gray-600'
                                } hover:text-[#7a70ba] text-[14px] font-[500] text-gray-600`
                            }>
                            Profile
                        </NavLink>
                        <NavLink to='passwordchange' className={({ isActive }) =>
                            `text-sm font-medium ${isActive ? 'text-[#7a70ba]' : 'text-gray-600'
                            } hover:text-[#7a70ba] text-[14px] font-[500] text-gray-600`
                        }>
                            Password Change
                        </NavLink>
                        <NavLink to='logout' className={({ isActive }) =>
                            `text-sm font-medium ${isActive ? 'text-[#7a70ba]' : 'text-gray-600'
                            } hover:text-[#7a70ba] text-[14px] font-[500] text-gray-600`
                        }>
                            Logout
                        </NavLink>
                    </div>
                </div>
            }


            



        </>
    )
}

export default Agentprofile
